import { Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import TeamDashboard from './pages/TeamDashboard'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import ContactPage from './pages/ContactPage'
import CookiePolicyPage from './pages/CookiePolicyPage'
import OnboardingPage from './pages/OnboardingPage'
import OnboardingGuard from './components/guards/OnboardingGuard'
import { SettingsApplier } from './providers/SettingsApplier'

function App() {
  return (
    <div
      className="min-h-screen"
      style={{
        backgroundColor: 'var(--color-bg)',
        color: 'var(--color-text-primary)',
      }}
    >
      {/* Settings Applier - applies CSS custom properties globally */}
      <SettingsApplier />

      <Routes>
        {/* Public routes - accessible without onboarding */}
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/cookies" element={<CookiePolicyPage />} />

        {/* Onboarding route - the e-learning flow */}
        <Route path="/onboarding/*" element={<OnboardingPage />} />

        {/* Protected routes - require hard gate completion (modules 1-3) */}
        <Route element={<OnboardingGuard />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/dashboard" element={<TeamDashboard />} />
        </Route>
      </Routes>
    </div>
  )
}

export default App
